import { createContext } from "react";

//form error

//form info
export interface IDocumentUploaderFormContext {
  mode: "Upload" | "Reupload";
}
export const DocumentUploadFormContext = createContext<IDocumentUploaderFormContext | null>(null);
